import { GridColumns, GridColDef, GridRowsProp, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import { createActionsColumn } from './actionsColumn';

export const brokerViewColumns: GridColDef[] = [
  createActionsColumn({
    showView: true,
    showEdit: true,
    getViewUrl: (row: any) => `/listadmin/${row.listadmin_id}?mode=view`,
    getEditUrl: (row: any) => `/listadmin/${row.listadmin_id}`,
    iconGapPx: 16,
  }),
    {
      field: 'company_id',
      type: 'string',
      headerName: 'Company ID',
      width: 120,
      valueGetter: (params) => params.row.company_sid || '',
    },
  // { field: 'listadmin_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  //   hide: true,
  // },
  {
    field: 'listadmin_sid',
    type: 'string',
    headerName: 'SID',
    width: 125,
  },
  {
    field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 200,
  },
  //  { field: 'address1',
  //   type: 'string',
  //   headerName: 'Address ',
  //   width: 150,
  // },
  // { field: 'address2',
  //   type: 'string',
  //   headerName: 'Address 2',
  //   width: 150,
  // },
  // { field: 'city',
  //   type: 'string',
  //   headerName: 'City',
  //   width: 150,
  // },
  // { field: 'state',
  //   type: 'string',
  //   headerName: 'State',
  //   width: 100,
  // },
  // { field: 'postal_code',
  //   type: 'string',
  //   headerName: 'Postal Code',
  //   width: 125,
  // },
  {
    field: 'federal_tax_id',
    type: 'string',
    headerName: 'Tax ID',
    width: 100,
    hide: true,
  },
  {
    field: 'naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 100,
  },
  {
    field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 100,
  },
  {
    field: 'representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
    valueGetter: (params) =>
      params.row.user && (params.row.user.first_name || params.row.user.last_name)
        ? `${params.row.user.first_name || ''} ${params.row.user.last_name || ''}`.trim()
        : '',
  },
  {
    field: 'representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
    valueGetter: (params) => params.row.title || '',
  },
  {
    field: 'representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
    valueGetter: (params) => params.row.user?.email || '',
  },
  {
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
  
];

export const brokerRelatedPafsColumns: GridColDef[] = [
  // { field: 'paf_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  // },
  {
    field: 'paf_sid',
    type: 'string',
    headerName: 'PAF SID',
    width: 125,
  },
  {
    field: 'company__company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 250,
  },
  {
    field: 'company__dba_name',
    type: 'string',
    headerName: 'DBA Name',
    width: 200,
  },
  // { field: 'address1',
  //   type: 'string',
  //   headerName: 'Address ',
  //   width: 150,
  // },
  // { field: 'address2',
  //   type: 'string',
  //   headerName: 'Address 2',
  //   width: 150,
  // },
  // { field: 'city',
  //   type: 'string',
  //   headerName: 'City',
  //   width: 150,
  // },
  // { field: 'state',
  //   type: 'string',
  //   headerName: 'State',
  //   width: 100,
  // },
  // { field: 'postal_code',
  //   type: 'string',
  //   headerName: 'Postal Code',
  //   width: 125,
  // },
  // { field: 'federal_tax_id',
  //   type: 'string',
  //   headerName: 'Tax ID',
  //   width: 100,
  // },
  // { field: 'naics_code',
  //   type: 'string',
  //   headerName: 'NAICS',
  //   width: 100,
  // },
  // { field: 'phone',
  //   type: 'string',
  //   headerName: 'Phone',
  //   width: 100,
  // },
  {
    field: 'company__representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
  },
  {
    field: 'company__representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
  },
  {
    field: 'company__representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
  },
  {
    field: 'expiration_date',
    type: 'dateTime',
    headerName: 'Expiry Date',
    width: 175,
  },
  {
    field: 'create_datetime',
    type: 'dateTime',
    headerName: 'Created At',
    width: 175,
  },
  {
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];
